import PropTypes from 'prop-types';
import React from 'react';
import errorMessage from '../../../../constants/errorMessages';
import './styles.scss';

const ErrorMessage = ({ messageId }) => (
  <section>
    {messageId ? errorMessage.defaultServerErrorWithId(messageId) : errorMessage.defaultServerError}
  </section>
);

ErrorMessage.propTypes = {
  messageId: PropTypes.number,
};

export default ErrorMessage;
